// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Drawer-module__Container__Hr6sB {
    /* Override the UA popover centering to anchor right at full height; width
       comes from the inner Box, the surface too. Top layer ignores z-index. */
    position: fixed;
    inset: 0 0 0 auto;
    width: var(--ds-vw-38);
    height: 100%;
    padding: var(--ds-s);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Drawer-module__Container__Hr6sB`
};
export default ___CSS_LOADER_EXPORT___;
